export default {
    it: {
        no_ticket_html: 'In questo terminale non è possibile aprire ticket. <br/> Le informazioni presenti in questa pagine sono sufficienti per risolvere la problematica.'
    },
    en: {
        no_ticket_html: 'In this terminal, it is not possible to open tickets. <br/> The information on this page is sufficient to resolve the issue.'
    }
}